import {Component, ChangeDetectorRef} from '@angular/core';
import { AppComponent } from "../../../app.component";
import { ConfigService } from '../../../config/config.service';
import 'rxjs/add/operator/toPromise';

@Component({
  selector: 'nav-bar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent  {

    constructor(private readonly ref:ChangeDetectorRef,
                public readonly appComponent: AppComponent,
                public readonly configService: ConfigService) {
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}
